var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-responsive embed-responsive--16by9"},[_c('iframe',{staticClass:"embed-responsive__item",attrs:{"src":_vm.url,"title":_vm.title,"allow":"autoplay; fullscreen","allowtransparency":"true","scrolling":"no","msallowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }